<template>
  <div class="pt-1">
    <v-data-table
      calculate-widths
      class="elevation-0 main__light_green table-visible-views"
      data-qa="data-table"
      disable-pagination
      :expanded="expanded"
      fixed-header
      :headers="headers"
      hide-default-footer
      item-key="id"
      :items="itemsWithId"
      :loading-text="$t('Tenders.Loading')"
      :no-data-text="$t('Tenders.NoData')"
      :no-results-text="$t('Tenders.NoData')">
      <template
        v-slot:item="{ item }">
        <tr
          :class="{'pointer' :$can('show', 'showBiddedLotsInTenderViditPage') && item?.lots?.length }"
          @click.stop="expand(item)">
          <td
            v-if="hideViewByParticipantsDuringBidReceptionOrAuction"
            class="text-left"
            colspan="4"
            data-qa="infoShowAfterFinishBidding">
            {{ $t('Tenders.InfoShowAfterFinishBidding') }}
          </td>
          <template v-else>
            <td
              class="text-left"
              data-qa="organizationShortTitle">
              {{ item.organizationShortTitle }}
            </td>
            <td
              class="text-start"
              data-qa="organizationUserou">
              {{ item.organizationUserou }}
            </td>
            <td data-qa="userName">
              <p
                class="mb-1"
                data-qa="userName">
                {{ item.userName }}
              </p>
              <p
                class="mb-0 h9-label"
                data-qa="userMail">
                {{ item.userMail }}
              </p>
            </td>
          </template>
          <td data-qa="userPhone">
            {{ item.userPhone }}
          </td>
          <td data-qa="viewsAmount">
            {{ item.viewsAmount }}
          </td>
          <td data-qa="lastViewDate">
            {{ item.lastViewDate }}
          </td>
          <td
            v-if="$can('show', 'showBiddedLotsInTenderViditPage')"
            data-qa="proposalType">
            <div class="text-right pr-8">
              <StatusChip
                class="my-auto"
                :data-qa="`proposalType-${item.proposalType}-status`"
                :name="$t(`Tenders.BidState.${item.proposalType}`)"
                :status="item.proposalType"/>
            </div>
          </td>
        </tr>
      </template>
      <template #expanded-item="{ headers: expandedHeaders, item }">
        <tr>
          <td
            class="table-subrow_item"
            :colspan="expandedHeaders.length">
            <div
              v-for="(lot, index) in item.lots"
              :key="index"
              class="table-visible-views_sub-row">
              {{ lot.lotLabel }}
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import StatusChip from 'components/common/elements/StatusChip.vue'
import godModeMixin from 'mixins/godModeMixin'

export default {
  name: 'TenderVisitsTable',
  mixins: [ godModeMixin ],
  data() {
    return {
      expanded: [],
      itemsWithId: []
    }
  },
  methods: {
    generateHash(item, index) {
      const str = JSON.stringify({
        index,
        organizationUserou: item.organizationUserou,
        userName: item.userName,
        userMail: item.userMail,
        viewsAmount: item.viewsAmount
      })
      let hash = 0
      for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i)
        hash = ((hash << 5) - hash) + char
        hash = hash & hash
      }
      return `item_${Math.abs(hash)}`
    },
    expand(item) {
      if (!this.$can('show', 'showBiddedLotsInTenderViditPage') || !item?.lots?.length) {
        return
      }
      const expandIndex = this.expanded.findIndex(exp => exp === item)

      if (expandIndex !== -1) {
        this.expanded.splice(expandIndex, 1)
      } else {
        this.expanded.push(item)
      }
    }
  },
  computed: {
    headers() {
      const result = [
        { text: this.$t('Tenders.Nomination'), value: 'organizationShortTitle', width: '20%', sortable: true },
        { text: this.$t('Tenders.EDRPOU'), value: 'organizationUserou', width: '20%', sortable: true },
        { text: this.$t('Tenders.ContactPerson'), value: 'userName', width: '15%', sortable: true },
        { text: this.$t('Common.PhoneNumber'), value: 'userPhone', width: '15%', sortable: true },
        { text: this.$t('Tenders.Views'), value: 'viewsAmount', width: '15%', sortable: true },
        { text: this.$t('Tenders.DateOfLast'), value: 'lastViewDate', width: '15%', sortable: true },
      ]
      if (this.$can('show', 'showBiddedLotsInTenderViditPage')) {
        result.push(
          { text: this.$t('Tenders.proposalType'), value: 'proposalType', width: '150px', sortable: true }
        )
      }
      return result
    },
    hideViewByParticipantsDuringBidReceptionOrAuction() {
      if (![4, 7].includes(this.tender.tenderStatus.id)) {
        return false
      }
      if (this.mixin_isGodMode) {
        return false
      }
      return this.$can('is', 'hideViewByParticipantsDuringBidReceptionOrAuction')
    },
  },
  components: {
    StatusChip,
  },
  props: {
    items: Array,
    tender: Object
  },
  watch: {
    items: {
      immediate: true,
      handler(newItems) {
        if (!newItems) {
          this.itemsWithId = []
          return
        }
        this.itemsWithId = newItems.map((item, index) => ({
          ...item,
          id: this.generateHash(item, index)
        }))
      }
    }
  }
}
</script>
<style lang="scss">
.table-visible-views {
  &_sub-row {
    text-align: left;
    padding: 8px 0 !important;
    margin: 0 10px 0 0;
    text-align: left;
    border-bottom: thin solid var(--v-main__green-base);
    &:nth-child(1) {
      padding-top: 0 !important;
    }
    &:last-child {
      padding-bottom: 0 !important;
      border-bottom: none;
    }
  }
  tr.v-data-table__expanded.v-data-table__expanded__row {
    td:nth-child(1),
    td:last-child {
      border-bottom: thin solid rgba(var(--black-color-rgba),.12) !important;
    }
  }
}
</style>

